import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';
import radium from 'radium';
import TakeOverShippingAddress from './TakeOverShippingAddress.jsx';

// Styles
import './TicketAddressFormHeadline.scss';

function TicketAddressFormHeadline(props) {
	const context = React.useContext(ThemeContext);
	const displayTicket = props.displayTicket;
	const style = {
		eventTitle: {
			fontSize: context.themeManager.value('ticket-address-form-event-title', 'fontSize', 'font-size-150'),
			lineHeight: context.themeManager.value('ticket-address-form-event-title', 'lineHeight', 'line-height-100'),
		},
	};
	return (
		<div className="form-headline__container">
			<div className="form-headline__event" style={style.eventTitle}>{displayTicket.event}</div>
			<div className="form-headline__seat-info">
				<span className="seat-info__element">{displayTicket.category}</span>
				<span className="seat-info__element">{displayTicket.priceLevel}</span>
				{ displayTicket.block &&
					<span className="seat-info__element">Block {displayTicket.block}</span>
				}
				{ displayTicket.rowNumber &&
					<span className="seat-info__element">Reihe {displayTicket.rowNumber}</span>
				}
				{ displayTicket.seatNumber &&
					<span className="seat-info__element">Sitz {displayTicket.seatNumber}</span>
				}
				{ (displayTicket.isVisualBulkTicket || (!displayTicket.isVisualBulkTicket && !displayTicket.isVisualTicket)) &&
					<span className="seat-info__element">Freie Platzwahl</span>
				}
			</div>
			<TakeOverShippingAddress ticketItemUuid={displayTicket.ticketItemUuid} />
		</div>
	);
}

export default radium(TicketAddressFormHeadline);
